import moment from 'moment';
export default {
  data() {
    return {
      dateRange: {} //时间段
    };
  },
  props: {
    controlData: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.dateRange = this.getDaterange();
  },
  mounted() {},
  computed: {
    item() {
      return this.controlData;
    }
  },
  methods: {
    changeFun() {
      this.$emit('valueChange', this.item.mark);
    },
    disabledDate(current) {
      return current && (current.isBefore(this.dateRange.startDateTime) || current.isAfter(this.dateRange.endDateTime));
    },
    disabledTime(current) {
      if (!current && this.range) {
        return {
          disabledHours: () => this.range(0, 24).splice(0, 24),
          disabledMinutes: () => this.range(0, 60),
          disabledSeconds: () => this.range(0, 60)
        };
      }
      const selectedDate = moment(current).format('YYYY-MM-DD'); // 当前选中年月日

      // 定义要禁用的时间范围
      const disabledRangeStartHour = moment(this.dateRange.startDateTime).hours(); // 开始小时
      const disabledRangeEndHour = moment(this.dateRange.endDateTime).hours(); // 结束小时
      const disabledRangeStartMinute = moment(this.dateRange.startDateTime).minutes(); // 开始分钟
      const disabledRangeEndMinute = moment(this.dateRange.endDateTime).minutes(); // 结束分钟
      const disabledRangeStartSecond = moment(this.dateRange.startDateTime).seconds(); // 开始秒
      const disabledRangeEndSecond = moment(this.dateRange.endDateTime).seconds(); // 结束秒
      // // 如果当前时间在指定的时间段内，则禁用
      if (disabledRangeStartHour <= disabledRangeEndHour || disabledRangeStartMinute <= disabledRangeEndMinute || disabledRangeStartSecond <= disabledRangeEndSecond) {
        if (this.dateRange.startDateTime === this.dateRange.endDateTime) {
          return {
            disabledHours: () => [...Array(24).keys()].filter(hour => hour < disabledRangeStartHour || hour > disabledRangeEndHour),
            disabledMinutes: () => [...Array(60).keys()].filter(minute => minute < disabledRangeStartMinute || minute > disabledRangeEndMinute),
            disabledSeconds: () => [...Array(60).keys()].filter(second => second < disabledRangeStartSecond || second > disabledRangeEndSecond)
          };
        } else if (selectedDate === this.dateRange.startDateTime) {
          return {
            disabledHours: () => [...Array(24).keys()].filter(hour => hour < disabledRangeStartHour),
            disabledMinutes: () => [...Array(60).keys()].filter(minute => minute < disabledRangeStartMinute),
            disabledSeconds: () => [...Array(60).keys()].filter(second => second < disabledRangeStartSecond)
          };
        } else if (selectedDate === this.dateRange.endDateTime) {
          return {
            disabledHours: () => [...Array(24).keys()].filter(hour => hour > disabledRangeEndHour),
            disabledMinutes: () => [...Array(60).keys()].filter(minute => minute > disabledRangeEndMinute),
            disabledSeconds: () => [...Array(60).keys()].filter(second => second > disabledRangeEndSecond)
          };
        }
      }

      // 如果当前时间不在时间段内，则不禁用
      return {};
    },
    // 获取日期范围
    getDaterange() {
      if (!this.item.dateStart.type && !this.item.dateEnd.type) return;
      let startDateTime = '1900-01-01 00:00:00'; //区间上限
      let endDateTime = '2100-12-31 24:00:00'; //区间下限
      // dateType 日期格式：1.YYYY-MM-DD 2.YYYY-MM-DD HH:mm:ss
      // dateStart: {
      //   type: undefined, // 1.无限制:UNLIMITED 2.特定时间:SPECIFIC_TIME 3.当前时间前:TIME_FRONT 4.当前时间后:TIME_AFTER
      //   value: '', // 当type等于特定时间，日期的值，例如：2023-09-10
      //   unit: undefined, // 当type等于当前时间前和当前时间后，选择的类型，例如：日:DAY 月:MONTH 年:YEAR
      //   dateInput: undefined, // 当type等于当前时间前和当前时间后，输入的数值
      // },
      // dateEnd: {
      //   type: undefined, // 1.无限制:UNLIMITED 2.特定时间:SPECIFIC_TIME 3.当前时间前:TIME_FRONT 4.当前时间后:TIME_AFTER
      //   value: '', // 当type等于特定时间，日期的值，例如：2023-09-10
      //   unit: undefined, // 当type等于当前时间前和当前时间后，选择的类型，例如：日:DAY 月:MONTH 年:YEAR
      //   dateInput: undefined, // 当type等于当前时间前和当前时间后，输入的数值
      // },

      // 测试使用
      // this.item.dateStart = {
      //   type: 'SPECIFIC_TIME',
      //   value: '2017-07-07',
      //   unit: '',
      //   dateInput: ''
      // };
      // this.item.dateEnd = {
      //   type: 'TIME_AFTER',
      //   value: '',
      //   unit: 'MONTH',
      //   dateInput: '2'
      // };
      // this.item.dateType = 'YYYY-MM-DD HH:mm:ss';

      let computeStartDate = this.computeTime(this.item.dateStart.type, this.item.dateStart.value, this.item.dateStart.unit, this.item.dateStart.dateInput); // 计算出来的开始日期时间
      let computeEndDate = this.computeTime(this.item.dateEnd.type, this.item.dateEnd.value, this.item.dateEnd.unit, this.item.dateEnd.dateInput); // 计算出来的开始日期时间
      if (computeStartDate) {
        startDateTime = computeStartDate;
      }
      if (computeEndDate) {
        endDateTime = computeEndDate;
      }
      if (this.item.dateType === 'YYYY-MM-DD') {
        startDateTime = moment(startDateTime).format(this.item.dateType);
        endDateTime = moment(endDateTime).format(this.item.dateType);
      }
      const rangeObj = {
        startDateTime: startDateTime,
        endDateTime: endDateTime
      };
      return rangeObj;
    },
    // 计算日期时间
    computeTime(type, value, unit, dateInput) {
      if (type === 'UNLIMITED') {
        // 无限制
        return 0;
      } else if (type === 'SPECIFIC_TIME') {
        // 特定时间
        return moment(value).format('YYYY-MM-DD HH:mm:ss');
      } else if (type === 'TIME_FRONT') {
        // 当前时间前
        return this.getAppointDate(unit, dateInput, '-');
      } else if (type === 'TIME_AFTER') {
        // 当前时间后
        return this.getAppointDate(unit, dateInput, '+');
      }
    },
    // 获取指定日期时间
    getAppointDate(unit, dateInput, direction) {
      let appointDate = '';
      const now = new Date();
      let newDateInput = parseInt(direction + dateInput);
      if (unit === 'DAY') {
        appointDate = moment(new Date(now.getTime() + newDateInput * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss');
      } else if (unit === 'MONTH') {
        appointDate = moment(new Date(now.getFullYear(), now.getMonth() + newDateInput, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds())).format('YYYY-MM-DD HH:mm:ss');
      } else if (unit === 'YEAR') {
        appointDate = moment(new Date(now.getFullYear() + newDateInput, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds())).format('YYYY-MM-DD HH:mm:ss');
      }
      return appointDate;
    }
  }
};